module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-f7755fefb8e66394a5b2995ea46434c3.webp";